export default "/images/81021bd5cfcb00d489538810424b501f.avif";